

















































import { Component, Vue } from 'vue-property-decorator';
import Modal from '@/components/Modal.vue';
import Login from '@/components/Login.vue';
import SignUp from '@/components/SignUp.vue';
import store from '@/store';
import { INFO_SITE, ALT_INFO_SITE } from '@/config';

@Component({
  components: {
    Login,
    SignUp,
    Modal,
  },
  data: () => ({
    INFO_SITE,
    ALT_INFO_SITE,
  }),
})
export default class Home extends Vue {
  public showLoginModal = false;
  public showSignUpModal = false;

  public created() {
    this.showLoginModal = !this.loggedIn && !!this.$route.query.showLogin;
    this.showSignUpModal = !this.loggedIn && !!this.$route.query.showSignUp;

    if (this.$route.query.showPlay) {
      if (this.loggedIn) {
        this.$router.push('/selectGame?mode=play');
      } else {
        this.$router.push('/selectGame?mode=watch');
      }
    }
  }

  get loggedIn() {
    return store.getters['auth/authenticated'];
  }
}
